import * as THREE from "three";

class PaintingGemWars {
  constructor(mesh) {
    this._mesh = mesh;
    this._startingPosition = new THREE.Vector3(3.3, 3.85, 6.15);
    this._startingLookAt = new THREE.Vector3(3.3, 3.85, -20);

    this._mesh.position.copy(this._startingPosition);
    this._mesh.lookAt(this._startingLookAt);

    this._mesh.traverse((x) => {
      if (x instanceof THREE.Mesh) {
        switch (x.material.name) {
          case "GemWars_PaintingTexture":
            this._paintingTexture = x;
            this._paintingMaterialOrig = x.material;
            this._paintingMaterial = new THREE.MeshBasicMaterial({
              map: x.material.map,
              name: x.name,
            });
            break;
          case "UnderConstruction":
            this._underConstruction = x;
            x.visible = false;

            const mat = new THREE.MeshBasicMaterial({
              map: x.material.map,
              name: x.name,
            });
            x.material.dispose();
            x.material = mat;
            break;
          default:
            break;
        }
      }
    });
  }
  setLinksActive = (isActive) => {
    this._underConstruction.visible = isActive;
  };
  setMaterial = (isShowingPaining) => {
    this._paintingTexture.material = isShowingPaining ? this._paintingMaterial : this._paintingMaterialOrig;
  };
  getLinkUrl = (mesh) => {
    return undefined;
  };
  get name() {
    return "GemWars";
  }
  get mesh() {
    return this._mesh;
  }
  get startingPosition() {
    return this._startingPosition;
  }
  get startingLookAt() {
    return this._startingLookAt;
  }
}
export default PaintingGemWars;
